import React from 'react';
import DirectusSDK from '@directus/sdk-js';
import HeadlessConfig from '../config/headless';
import ListItem from '../components/list_item';
import ListFilter from '../components/list_filter';
import NoRecords from '../components/no_records';

import './l_angebote.css';
import TypeNav from '../components/type_nav';
import BnbHeader from '../components/bnb_header';


const client = new DirectusSDK();
client.login({
  url: HeadlessConfig.url,
  project: HeadlessConfig.project,
  email: HeadlessConfig.email,
  password: HeadlessConfig.password
});

export default class AngeboteListView extends React.Component {
  constructor(props) {
    super(props);

    this.onChangeFilter = this.onChangeFilter.bind(this);

    this.state = {
      angebote: [],
      filter: {},
      isLoaded: false
    };
  }

  componentWillMount()  {
    this.loadRecords();
  }

  loadRecords() {
    client
      .getItems('bnb_angebote', {
        filter: {
          active: {
            eq: 1
          },
          published: {
            eq: 1
          },
          inserat_typ: {
            eq: 0
          },
          ...this.state.filter
        }
      })
      .then(data => {
        this.setState({ angebote: data.data, isLoaded: true });
      })
      .catch(err => {
        console.error(err);
      });
  }

  onChangeFilter(filter) {
    if (filter !== "") {
      this.setState({ filter: { number: { gte: filter } } });
      setTimeout(() => {
        this.loadRecords();
      }, 100);
    }
  }

  render() {
    return <div>
        <BnbHeader site={'angebote'} />
        <ListFilter onChangeEvt={this.onChangeFilter} type="angebot"/>
        <div className="list_grid">
          {this.state.isLoaded && this.state.angebote.length === 0 && <NoRecords multiple={true} type={'angebot'} />}
          {this.state.isLoaded && this.state.angebote.map(angebot => (
              <ListItem item={angebot} key={angebot.id} type="angebot" />
            ))}
        </div>
      </div>;
  }
}